<!-- Loading Spinner Overlay -->
@if (isLoading) {
    <div class="loading-overlay">
        <div class="spinner-container flex items-center justify-center">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </div>
}

<!-- Overlay Confirmation Panel for bulk selection of activities -->
<!-- TODO check if this confirm panel can be deleted! I don't see where this is opened... -->
<p-popover #confirmPanel [dismissable]="false" appendTo="body" [style]="{ width: '300px' }">
    <div class="flex items-center" style="display: flex; align-items: center; gap: 0.5rem; padding: 10px">
        <span>{{ "bulk_selection_label" | translate: { totalCount: totalCount } }}</span>
    </div>
    <div class="flex justify-end gap-4" style="padding-top: 10px">
        <button type="submit" pButton (click)="onCancel()" class="p-button-text" style="color: blue; margin-right: 10px">
            {{ "standard_no" | translate }}
        </button>
        <button type="submit" pButton severity="primary" (click)="confirmBulkSelection(confirmPanel)" class="p-button-outlined" [loading]="isLoading">
            {{ "standard_yes" | translate }}
        </button>
    </div>
</p-popover>

@if (dataState === "no-data") {
    <div>
        <div class="mb-16 flex justify-center">
            <div class="mt-16">
                <div class="text-center items-center">
                    <div class="mt-1">
                        <img class="inline" src="{{ 'activities_detail_nodata_link' | translate }}" width="40%" height="40%" alt="No data" />
                    </div>
                    <div class="mb-12">
                        <h4>{{ "activities_detail_nodata_title" | translate }}</h4>
                        <p [innerHTML]="'activities_detail_nodata_text1' | translate"></p>
                    </div>

                    <p class="mb-2" style="color: #818181">{{ "dashboard_nodata_text2" | translate }}</p>

                    <div class="mb-6">
                        <a [routerLink]="['/apps']">
                            <img class="inline" style="width: 35%; height: 35%" src="/assets/images/app-icons.png" alt="App icons" />
                        </a>
                    </div>
                    <div class="mb-2">
                        <p-button
                            data-testid="activity-add"
                            severity="primary"
                            pRipple
                            type="button"
                            styleClass="p-button-outlined"
                            class="icon-button-fix"
                            (click)="addNewActivity()"
                            label="{{ 'activities_add_times' | translate }}"
                            icon="pi pi-plus"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
}

@if (dataState === "empty-result") {
    <div class="card h-[30vh] md:h-[80%]">
        <div class="flex justify-between content-center items-center flex-wrap">
            <div class="flex items-center" style="gap: 1rem">
                <div class="text-xl font-semibold" [ngClass]="{ 'font-bold': reportSettings.roundingEnabled && licenseStatePro }">
                    {{ "activities_total" | translate }}: {{ totalDuration }}
                </div>
                <button data-testid="activity-add" pButton type="button" class="p-button-outlined" (click)="addNewActivity()">
                    <i class="pi pi-plus"></i> {{ "activities_add_times" | translate }}
                </button>
            </div>
        </div>
        <div class="flex justify-center items-center h-full">
            <div class="flex flex-col items-center">
                <i class="pi pi-filter text-gray-400 mb-6" style="font-size: 3.5rem"></i>
                <h4 class="mb-6">{{ "activities_empty_filter_result_heading" | translate }}</h4>
                <p class="text-gray-500">{{ "activities_empty_filter_result_text" | translate }}</p>
            </div>
        </div>
    </div>
}

@if (dataState === "has-data") {
    <div>
        <div class="card">
            <p-table
                data-testid="activity-table"
                [value]="activities"
                responsiveLayout="scroll"
                [columns]="cols"
                exportFilename="{{ getCsvFileName() }}"
                selectionMode="single"
                [(selection)]="selectedActivity"
                (onRowSelect)="onRowSelect($event)"
                [paginator]="true"
                [rows]="paginationRows"
                [totalRecords]="totalCount"
                [first]="paginationFirst"
                [sortField]="sortField"
                [sortOrder]="sortOrder"
                [rowsPerPageOptions]="[25, 50]"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="{{ 'table_pagination_showing' | translate }} {first} {{ 'table_pagination_to' | translate }} {last} {{
                    'table_pagination_of' | translate
                }} {totalRecords} {{ 'table_pagination_entries' | translate }}"
                [lazy]="true"
                (onLazyLoad)="onLazyLoadHandler($event)"
                class="time-entries-table"
            >
                <ng-template pTemplate="caption">
                    @let showSubTotal = selectedActivities.size > 0;
                    <div class="flex justify-between content-center items-center flex-wrap min-h-15 mb-1 mt-[-0.5rem]">
                        <div class="flex items-center" style="gap: 1rem">
                            <div>
                                <div
                                    data-testid="activity-total"
                                    class="text-xl font-semibold"
                                    [ngClass]="{ 'font-bold': reportSettings.roundingEnabled && licenseStatePro }"
                                >
                                    {{ "activities_total" | translate }}: {{ totalDuration }}
                                </div>
                                @if (showSubTotal) {
                                    <div data-testid="activity-selection-summary" class="text-sm block tb-text-gray">
                                        <!-- {{ "activities_subtotal" | translate }} -->
                                        {{ selectedActivities.size }} {{ "activities_selected" | translate }}:
                                        <span class="font-bold">{{ subTotalDuration }}</span>
                                    </div>
                                }
                            </div>
                            <button data-testid="activity-add" pButton type="button" class="p-button-outlined" (click)="addNewActivity()">
                                <i class="pi pi-plus"></i> {{ "activities_add_times" | translate }}
                            </button>
                        </div>

                        <div class="flex items-center" style="gap: 0.5rem">
                            <!-- Select action btn for group time entry selection-->
                            <button
                                data-testid="activity-bulk-menu"
                                *ngIf="selectedActivities.size > 0"
                                type="button"
                                pButton
                                icon="pi pi-chevron-down"
                                iconPos="right"
                                class="p-button-text"
                                [label]="getBulkEditButtonLabel()"
                                (click)="menuPanel.toggle($event)"
                            ></button>

                            <p-popover #menuPanel [dismissable]="true" appendTo="body">
                                <div style="display: flex; flex-direction: column; gap: 0.5rem">
                                    @if (hasReadTeamPermission()) {
                                        <button
                                            data-testid="activity-bulk-billed"
                                            pButton
                                            type="button"
                                            [disabled]="selectedActivities.size === 0 || !licenseStatePro"
                                            pTooltip="{{ (!licenseStatePro ? 'tooltip_billed_button' : '') | translate }}"
                                            tooltipPosition="top"
                                            (click)="onClick('billed')"
                                            class="p-button-text flex items-center justify-start w-full"
                                        >
                                            <i class="pi pi-money-bill mr-2"></i>
                                            <span class="grow text-left">
                                                {{
                                                    allSelActAreBilled
                                                        ? ("activities_multistatuschange_unbilled" | translate)
                                                        : ("activities_mulitstatuschange" | translate)
                                                }}
                                            </span>
                                        </button>
                                    }
                                    <!-- Menu Item: Delete -->
                                    <button
                                        data-testid="activity-bulk-delete"
                                        pButton
                                        severity="danger"
                                        type="button"
                                        [disabled]="selectedActivities.size === 0"
                                        (click)="onClick('delete')"
                                        class="p-button-text flex items-center justify-start w-full"
                                    >
                                        <i class="pi pi-trash mr-2"></i>
                                        <span class="grow text-left">{{ "activities_multidelete" | translate }}</span>
                                    </button>
                                </div>
                            </p-popover>
                            <!-- Time rounding component -->
                            <p-menu [popup]="true" [model]="actionMenu" appendTo="body"></p-menu>
                            <div class="rounding-border" style="text-align: center; display: flex; align-items: center; border-radius: 4px; height: 100%">
                                <!-- Switch -->
                                <div
                                    pTooltip="{{ 'time_rounding_proFeature' | translate }}"
                                    [tooltipDisabled]="licenseStatePro"
                                    tooltipPosition="left"
                                    style="display: flex; justify-content: center; align-items: center; width: 3rem; height: 2.1rem; position: relative"
                                >
                                    <div style="display: flex; justify-content: center; align-items: center; transform: scale(0.6) translateY(10%)">
                                        <p-toggleswitch
                                            data-testid="activity-rounding-toggle"
                                            [(ngModel)]="roundingEnabled"
                                            (onChange)="onRoundingEnabledChange()"
                                            [disabled]="!licenseStatePro"
                                        />
                                    </div>
                                </div>
                                <!-- Label -->
                                <div
                                    pTooltip="{{ 'time_rounding_proFeature' | translate }}"
                                    [tooltipDisabled]="licenseStatePro"
                                    tooltipPosition="top"
                                    style="
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        flex-grow: 1;
                                        font-weight: normal;
                                        align-self: stretch;
                                        margin-right: 0.5rem;
                                        cursor: pointer;
                                    "
                                >
                                    <button
                                        data-testid="activity-rounding-enable"
                                        type="submit"
                                        pButton
                                        severity="primary"
                                        pRipple
                                        class="p-button p-button-text"
                                        (click)="onRoundingEnabledChange(true)"
                                        [disabled]="!licenseStatePro"
                                        style="padding-left: 0; padding-right: 0; border: none; margin: 0"
                                    >
                                        {{ "time_rounding" | translate }}
                                    </button>
                                </div>
                                <!-- Settings Button -->
                                <div
                                    class="rounding-border-left"
                                    pTooltip="{{ 'time_rounding_proFeature' | translate }}"
                                    [tooltipDisabled]="licenseStatePro"
                                    tooltipPosition="top"
                                    style="border-top-right-radius: 4px; border-bottom-right-radius: 4px; margin: -1px"
                                >
                                    <button
                                        data-testid="activity-rounding-settings"
                                        type="submit"
                                        pButton
                                        severity="primary"
                                        pRipple
                                        class="p-button p-button-text"
                                        style="padding-left: 7px; padding-right: 7px; opacity: 1"
                                        (click)="openRoundingSettings($event)"
                                        [disabled]="!licenseStatePro"
                                    >
                                        <i class="pi pi-angle-down" [class.rotate-icon]="isRoundingIconRotated"></i>
                                    </button>
                                </div>
                            </div>

                            <p-popover
                                #roundingOptionsOverlay
                                [dismissable]="true"
                                styleClass="p-mt-0"
                                (onShow)="onRoundingOverlayShow()"
                                (onHide)="onRoundingOverlayHide()"
                            >
                                <div class="p-fluid">
                                    <div class="p-field mb-2">
                                        <p-select
                                            data-testid="activity-rounding-type"
                                            inputId="dropdownRoundingType"
                                            [options]="durationRoundingTypeOptions"
                                            [(ngModel)]="selectedDurationRoundingType"
                                            optionValue="code"
                                            optionLabel="name"
                                        />
                                    </div>
                                    <div class="p-field mb-2">
                                        <p-select
                                            data-testid="activity-rounding-unit"
                                            inputId="dropdownTimeRounding"
                                            [options]="durationRoundingUnitsOptions"
                                            [(ngModel)]="selectedDurationRoundingUnit"
                                            optionValue="code"
                                            optionLabel="name"
                                        />
                                    </div>
                                    <p-button data-testid="activity-rounding-apply" label="Apply" class="p-mt-2" (onClick)="applyRoundingSettings()"></p-button>
                                </div>
                            </p-popover>

                            <button
                                data-testid="report-customization-open"
                                pButton
                                type="button"
                                class="p-button-outlined"
                                (click)="openReportCustomization()"
                                style="padding: 7px"
                            >
                                <svg fill="none" height="20" viewBox="0 0 16 16" width="20" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="m6.99976 5c0-2.20914 1.79087-4 4.00004-4 .5087 0 .9965.09524 1.4455.26931.1576.06109.2736.19767.3085.36304.0348.16538-.0162.33718-.1357.45669l-1.911 1.91108 1.2929 1.2929 1.9109-1.91095c.1195-.11953.2913-.17057.4567-.1357.1654.03488.3019.15095.363.30856.174.44887.2692.93645.2692 1.44507 0 2.20914-1.7909 4-4 4-.3801 0-.7485-.05316-1.09778-.15264l-5.00648 5.07184c-.71395.7233-1.85874.7909-2.65278.1565-.91412-.7302-1.002-2.0885-.18961-2.9304l5.05084-5.23469c-.06823-.2929-.10423-.59782-.10423-.91061zm4.00004-3c-1.65689 0-3.00004 1.34315-3.00004 3 0 .31548.04853.61868.13817.90305.05508.17476.01016.36564-.11706.49749l-5.24809 5.43906c-.40331.418-.35968 1.0923.09413 1.4548.39419.3149.96252.2814 1.31695-.0777l5.22419-5.2924c.13885-.14066.34752-.18633.53243-.11653.32872.12409.68542.19223 1.05932.19223 1.6568 0 3-1.34315 3-3 0-.0944-.0044-.18772-.0129-.27977l-1.6334 1.63345c-.0937.09377-.2209.14645-.3535.14645s-.2598-.05268-.3536-.14645l-1.99997-2c-.19526-.19526-.19526-.51183-.00001-.7071l1.63368-1.63369c-.0923-.00853-.1858-.01289-.2803-.01289z"
                                        fill="#2196f3"
                                    />
                                </svg>
                            </button>

                            <app-export-actions-panel
                                [licenseStatePro]="licenseStatePro"
                                [exportToPdf]="exportPdf"
                                [exportToExcel]="exportExcel"
                                [exportToCsv]="exportCsv"
                                [accountingIntegrations]="activeIntegrations"
                                [reauthIntegrations]="reauthIntegrations"
                                [rateLimitedIntegrations]="rateLimitedIntegrations"
                                [isAdmin]="isAdmin"
                                [selectedActivityIds]="getSelectedActivityIds()"
                                (openAccountingModal)="openInvoiceCreationModal($event)"
                            />
                        </div>
                    </div>
                </ng-template>
                <!-- column headers for time entries -->
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 4rem; cursor: default !important">
                            @if (areAllActivitiesLocked) {
                                <p-checkbox [disabled]="true" />
                            } @else {
                                <p-checkbox
                                    data-testid="activity-select-all"
                                    [binary]="true"
                                    [(ngModel)]="areAllActivitiesSelected"
                                    [disabled]="!areAllActivitiesSelected && selectedActivities.size >= MAX_SELECTION"
                                    pTooltip="{{
                                        !areAllActivitiesSelected && selectedActivities.size >= MAX_SELECTION
                                            ? ('max_bulk_activity_selection_label' | translate)
                                            : ''
                                    }}"
                                    (onChange)="selectAll($event.checked, $event.originalEvent)"
                                />
                            }
                        </th>
                        <th pSortableColumn="userName" *ngIf="isColumnVisible('activities_user')">
                            {{ "activities_user" | translate }}
                            <p-sortIcon field="userName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="layer1" *ngIf="isColumnVisible('layer_1')">
                            {{ getLayerName(1) }}
                            <p-sortIcon field="layer1"></p-sortIcon>
                        </th>
                        <th pSortableColumn="layer2" *ngIf="layers[1]?.visible === true && isColumnVisible('layer_2')">
                            {{ getLayerName(2) }}
                            <p-sortIcon field="layer2"></p-sortIcon>
                        </th>
                        <th pSortableColumn="layer3" *ngIf="layers[2]?.visible === true && isColumnVisible('layer_3')">
                            {{ getLayerName(3) }}
                            <p-sortIcon field="layer3"></p-sortIcon>
                        </th>
                        <th data-testid="activity-sort-note" pSortableColumn="note" *ngIf="isColumnVisible('activities_note')">
                            {{ "activities_note" | translate }}
                            <p-sortIcon field="note"></p-sortIcon>
                        </th>
                        <th pSortableColumn="local_start_date" *ngIf="isColumnVisible('activities_date')" style="width: 9rem">
                            {{ "activities_date" | translate }}
                            <p-sortIcon field="local_start_date"></p-sortIcon>
                        </th>
                        <th
                            pSortableColumn="local_start_time"
                            *ngIf="isColumnVisible('activities_time')"
                            [style.width]="reportSettings.timeFormat === 'hh:mm A' ? '14rem' : '10rem'"
                        >
                            {{ "activities_time" | translate }}
                            <p-sortIcon field="local_start_time"></p-sortIcon>
                        </th>
                        <th
                            data-testid="activity-sort-duration"
                            pSortableColumn="durationSeconds"
                            *ngIf="isColumnVisible('activities_duration')"
                            style="width: 9rem"
                        >
                            {{ "activities_duration" | translate }}
                            <p-sortIcon field="durationSeconds"></p-sortIcon>
                        </th>
                        <th pSortableColumn="billed" *ngIf="isColumnVisible('activities_billed')">
                            {{ "activities_billed" | translate }}
                            <p-sortIcon field="billed"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-activity>
                    <tr [pSelectableRow]="activity" [attr.data-testid]="'activity-row-' + activity.id">
                        <td
                            style="cursor: default !important"
                            (click)="$event.stopPropagation()"
                            (mousedown)="$event.stopPropagation()"
                            (mouseup)="$event.stopPropagation()"
                        >
                            @if (activity.lock?.locked && !activity.lock?.userCanOverride) {
                                <p-checkbox [disabled]="true" />
                                <!-- <i class="pi pi-lock"></i> -->
                            } @else {
                                <p-checkbox
                                    [attr.data-testid]="'activity-select-' + activity.id"
                                    [disabled]="!activity.isChecked && selectedActivities.size >= MAX_SELECTION"
                                    pTooltip="{{
                                        !activity.isChecked && selectedActivities.size >= MAX_SELECTION ? ('max_bulk_activity_selection_label' | translate) : ''
                                    }}"
                                    [binary]="true"
                                    [value]="activity.isChecked"
                                    [ngModel]="activity.isChecked"
                                    (onChange)="select(activity, $event.checked); $event.originalEvent?.stopPropagation()"
                                />
                            }
                        </td>
                        <td *ngIf="isColumnVisible('activities_user')">
                            {{ activity.userName }}
                        </td>
                        <td *ngIf="isColumnVisible('layer_1')">{{ activity.layer1 }}</td>
                        <td *ngIf="layers[1]?.visible === true && isColumnVisible('layer_2')">{{ activity.layer2 }}</td>
                        <td *ngIf="layers[2]?.visible === true && isColumnVisible('layer_3')">{{ activity.layer3 }}</td>
                        <td *ngIf="isColumnVisible('activities_note')" class="td-ellipsis">{{ activity.note }}</td>
                        <td *ngIf="isColumnVisible('activities_date')">{{ activity.date }}</td>
                        <td
                            *ngIf="isColumnVisible('activities_time')"
                            [ngClass]="{ 'font-bold': reportSettings.roundingEnabled && licenseStatePro }"
                            class="centered text-nowrap"
                        >
                            <span
                                *ngIf="activity.timezoneSwitch"
                                [pTooltip]="getTimezoneSwitchText(activity)"
                                [escape]="false"
                                tooltipStyleClass="time-detail-tooltip"
                                tooltipPosition="top"
                            >
                                {{ activity.time }}
                                <span style="margin-left: 5px" class="pi pi-globe"></span>
                            </span>

                            <span *ngIf="!activity.timezoneSwitch">{{ activity.time }}</span>
                        </td>
                        <td *ngIf="isColumnVisible('activities_duration')" [ngClass]="{ 'font-bold': reportSettings.roundingEnabled && licenseStatePro }">
                            {{ activity.duration }}
                        </td>
                        <td *ngIf="isColumnVisible('activities_billed')" [style.text-align]="'center'" [attr.data-testid]="'activity-billed-' + activity.id">
                            <i *ngIf="activity.billed" class="pi pi-check"></i>
                        </td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="paginatorleft"> </ng-template>
                <ng-template pTemplate="paginatorright"> </ng-template>
            </p-table>
        </div>
    </div>
}

@for (serviceId of activeIntegrations; track serviceId) {
    <app-create-invoice
        [serviceIdentifier]="serviceId"
        [reportSettings]="reportSettings"
        [allUsers]="allUsers"
        [filters]="filters"
        [layers]="layers"
        [invoiceTotalTime]="invoiceTotalTime"
        [activityIds]="getActivityIdsForExport()"
        (activitiesRefreshRequested)="onActivitiesRefreshRequested()"
    />
}

<app-add-activity
    [(showDialog)]="showAddEditDialog"
    [(selectedActivity)]="selectedActivity"
    [isNewActivityMode]="isNewActivityMode"
    [currentUserId]="currentUserId"
    (saved)="onSaved($event)"
    (deleted)="onDeleted($event)"
    (showDialogChange)="onAddEditDialogVisibilityChange($event)"
/>

@if (showReportCustomizationDialog || true) {
    <app-report-customization
        [(showDialog)]="showReportCustomizationDialog"
        (userLogoSelectionUrlChange)="onUserLogoSelectionUrlChange($event)"
        [uploadedCustomLogoUrl]="uploadedCustomLogoUrl"
        [userSelectedLogoUrl]="userSelectedLogoUrl"
    />
}
